var _a;
import { __assign } from "tslib";
import { optionsMap } from 'pro-gallery-lib';
import { PRIVATE_CONTROLLERS } from './private-controllers';
export var processProGalleryOptions = function (options) { return (__assign(__assign({}, Object.values(GalleryOptions).reduce(function (defaults, option) {
    var _a;
    return (__assign(__assign({}, defaults), (_a = {}, _a[option.key] = option.default, _a)));
}, {})), options)); };
var EditorSections = {
    LAYOUT: {
        key: 'LAYOUT',
        title: 'Choose a Layout',
        type: 'SECTION',
    },
    IMAGE_DISPLAY: {
        key: 'IMAGE_DISPLAY',
        title: 'Image Display',
        type: 'SECTION',
    },
    DESIGN_SETTINGS: {
        key: 'DESIGN_SETTINGS',
        title: 'Design Settings',
        type: 'SECTION',
    },
    SLIDESHOW_SETTINGS: {
        key: 'SLIDESHOW_SETTINGS',
        title: 'Slideshow Settings',
        type: 'SECTION',
    },
    INFO_SETTINGS: {
        key: 'INFO_SETTINGS',
        title: 'Info Settings',
        type: 'SECTION',
    },
    ADVANCED: {
        key: 'ADVANCED',
        title: 'Advanced',
        type: 'SECTION',
    },
    OVERLAY: {
        key: 'OVERLAY',
        title: 'Overlay',
        type: 'SECTION',
    },
};
export var GalleryOptions = (_a = {},
    _a[optionsMap.layoutParams.structure.galleryLayout] = {
        key: optionsMap.layoutParams.structure.galleryLayout,
        title: 'ProGallery_Layout_Tab_Custom_Label',
        description: 'ProGallery_Layout_Tab_Custom_Description',
        type: 'OPTIONS',
        options: [
            {
                value: 0,
                title: 'ProGallery_Layout_Layouts_Type12',
            },
            {
                value: 1,
                title: 'ProGallery_Layout_Layouts_Type13',
            },
            {
                value: 2,
                title: 'ProGallery_Layout_Layouts_Type3',
            },
            {
                value: 3,
                title: 'ProGallery_Layout_Layouts_Type7',
            },
            {
                value: 4,
                title: 'ProGallery_Layout_Layouts_Type8',
            },
            {
                value: 5,
                title: 'ProGallery_Layout_Layouts_Type9',
            },
            {
                value: 6,
                title: 'ProGallery_Layout_Layouts_Type10',
            },
            {
                value: 7,
                title: 'ProGallery_Layout_Layouts_Type6',
            },
            {
                value: 10,
                title: 'ProGallery_Layout_Layouts_Type14',
            },
            {
                value: 11,
                title: 'ProGallery_Layout_Layouts_Type15',
            },
            {
                value: 12,
                title: 'ProGallery_Layout_Layouts_Type16',
            },
        ],
        default: 0,
    },
    _a[optionsMap.layoutParams.structure.scrollDirection] = {
        key: optionsMap.layoutParams.structure.scrollDirection,
        title: 'Native_ProGallery_Layout_Orientation_Label',
        type: 'OPTIONS',
        default: 'VERTICAL',
        options: [
            {
                value: 'VERTICAL',
                title: 'ProGallery_Layout_DisplaySection_Option1',
            },
            {
                value: 'HORIZONTAL',
                title: 'ProGallery_Layout_DisplaySection_Option2',
            },
        ],
        description: 'ProGallery_Layout_DisplaySection_Direction_Tooltip',
    },
    _a[optionsMap.layoutParams.structure.layoutOrientation] = {
        key: optionsMap.layoutParams.structure.layoutOrientation,
        title: 'ProGallery_Layout_DisplaySection_Orientation_SubHeader',
        description: 'ProGallery_Layout_DisplaySection_Orientation_Tooltip',
        options: [
            {
                value: 'VERTICAL',
                title: 'ProGallery_Layout_DisplaySection_Orientation_Option1',
            },
            {
                value: 'HORIZONTAL',
                title: 'ProGallery_Layout_DisplaySection_Orientation_Option2',
            },
        ],
        type: 'OPTIONS',
        default: 'VERTICAL',
    },
    _a[optionsMap.behaviourParams.gallery.layoutDirection] = {
        key: optionsMap.behaviourParams.gallery.layoutDirection,
        title: 'ProGallery_Layout_Layout_Direction_Label',
        type: 'OPTIONS',
        default: 'LEFT_TO_RIGHT',
        options: [
            {
                value: 'LEFT_TO_RIGHT',
                title: 'ProGallery_Layout_Layout_Direction_LTR',
            },
            {
                value: 'RIGHT_TO_LEFT',
                title: 'ProGallery_Layout_Layout_Direction_RTL',
            },
        ],
        description: 'ProGallery_Layout_Layout_Direction_Tooltip',
    },
    _a[optionsMap.layoutParams.structure.itemSpacing] = {
        key: optionsMap.layoutParams.structure.itemSpacing,
        title: 'ProGallery_Layout_Spacing',
        description: 'ProGallery_Layout_Spacing_Tooltip',
        type: 'NUMBER',
        min: 0,
        max: 300,
        step: 1,
        default: 10,
    },
    _a[optionsMap.layoutParams.structure.numberOfGridRows] = {
        key: optionsMap.layoutParams.structure.numberOfGridRows,
        title: 'ProGallery_Layouts_Columns_Column_Label',
        description: 'ProGallery_Layouts_Columns_Column_Tooltip',
        default: 1,
        max: 3,
        min: 1,
        type: 'NUMBER',
    },
    _a[optionsMap.layoutParams.structure.numberOfColumns] = {
        key: optionsMap.layoutParams.structure.numberOfColumns,
        title: 'ProGallery_Layout_Layouts_Gallery_Row_Label',
        description: 'ProGallery_Layout_Layouts_Gallery_Row_Tooltip',
        default: 3,
        max: 3,
        min: 1,
        type: 'NUMBER',
    },
    _a[optionsMap.layoutParams.groups.density] = {
        key: optionsMap.layoutParams.groups.density,
        title: 'ProGallery_Layout_CollageDens_Label',
        description: 'ProGallery_Layout_CollageDens_Tooltip',
        type: 'FLOAT',
        default: 0.8,
        min: 0,
        max: 1,
        step: 0.1,
    },
    _a[optionsMap.layoutParams.targetItemSize.value] = {
        key: optionsMap.layoutParams.targetItemSize.value,
        title: 'ProGallery_Layout_Thumbnail_Size',
        description: 'ProGallery_Layout_Thumbnail_Size_Tooltip',
        type: 'NUMBER',
        default: 48,
        min: 1,
        max: 100,
        step: 1,
    },
    _a[optionsMap.layoutParams.crop.method] = {
        key: optionsMap.layoutParams.crop.method,
        title: 'ProGallery_Layout_Thumbnail_Resize',
        type: 'OPTIONS',
        default: 'FILL',
        options: [
            {
                value: 'FILL',
                title: 'ProGallery_Layout_Thumbnail_Crop',
            },
            {
                value: 'FIT',
                title: 'ProGallery_Layout_Thumbnail_Fit',
            }
        ],
        description: 'ProGallery_Layout_Thumbnail_Tooltip',
    },
    _a[optionsMap.layoutParams.crop.ratios] = {
        key: optionsMap.layoutParams.crop.ratios,
        type: 'OPTIONS',
        title: 'ProGallery_Layouts_Slider_ImageRatio_Label',
        description: "ProGallery_Layouts_Slider_ImageRatio_Tooltip",
        default: 1,
        options: [
            {
                value: 16 / 9,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item1',
            },
            {
                value: 4 / 3,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item2',
            },
            {
                value: 1,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item3',
            },
            {
                value: 3 / 4,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item4',
            },
            {
                value: 9 / 16,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item5',
            },
        ]
    },
    _a[optionsMap.layoutParams.structure.responsiveMode] = {
        key: optionsMap.layoutParams.structure.responsiveMode,
        title: 'Native_ProGallery_Layout_ResponsiveType',
        type: 'OPTIONS',
        default: 'FIT_TO_SCREEN',
        options: [
            {
                value: 'FIT_TO_SCREEN',
                title: 'ProGallery_Layouts_Grid_Responsive_Option1',
            },
            {
                value: 'SET_ITEMS_PER_ROW',
                title: 'ProGallery_Layouts_Grid_Responsive_Option2',
            },
        ],
        description: 'ProGallery_Layouts_Grid_Responsive_Tooltip',
    },
    _a[optionsMap.layoutParams.thumbnails.alignment] = {
        key: optionsMap.layoutParams.thumbnails.alignment,
        title: 'ProGallery_Layout_Layouts_Thumbnails_Placement_Label',
        type: 'OPTIONS',
        options: [
            {
                value: 'BOTTOM',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item1',
            },
            {
                value: 'TOP',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item2',
            },
            {
                value: 'RIGHT',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item3',
            },
            {
                value: 'LEFT',
                title: 'Native_ProGallery_Layout_ThumbnailPlacemento_List_Item4',
            },
        ],
        default: 'BOTTOM',
        description: 'ProGallery_Layoyt_Layouts_Thumbnails_Placement_Tooltip',
    },
    _a[optionsMap.layoutParams.thumbnails.size] = {
        key: optionsMap.layoutParams.thumbnails.size,
        title: 'ProGallery_Layout_Thumbnail_Size',
        type: 'NUMBER',
        default: 120,
        min: 80,
        max: 300,
        description: 'ProGallery_Layout_Thumbnail_Size_Tooltip',
    },
    _a[optionsMap.layoutParams.thumbnails.spacing] = {
        key: optionsMap.layoutParams.thumbnails.spacing,
        title: 'ProGallery_Layout_Layouts_Thumbnails_Spacing_Label',
        type: 'NUMBER',
        default: 4,
        min: 0,
        max: 30,
        description: 'ProGallery_Layout_Spacing_Tooltip',
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.enable] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.enable,
        title: 'ProGallery_Layout_LoadMore_Section_Label',
        description: 'Native_ProGallery_Layout_LoadMoreBtn_Toggle_Description',
        type: 'BOOLEAN',
        default: false,
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.text] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.text,
        title: 'ProGallery_Layout_LoadMore_Button_Title',
        description: 'Native_ProGallery_Layout_LoadMoreBtn_Text_Description',
        type: 'TEXT',
        default: 'Load More',
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.navigationDuration] = {
        key: optionsMap.behaviourParams.gallery.horizontal.navigationDuration,
        title: 'ProGallery_Settings_Design_Scroll_Duration_Title',
        type: 'NUMBER',
        default: 800,
        min: 100,
        max: 1000,
        step: 100,
        description: 'ProGallery_Settings_Design_Scroll_Duration_Tooltip',
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.loop] = {
        key: optionsMap.behaviourParams.gallery.horizontal.loop,
        title: 'ProGallery_Expand_Loop_Label',
        description: 'ProGallery_Expand_Loop_Tooltip',
        type: 'BOOLEAN',
        default: false,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval,
        title: 'ProGallery_Layout_SlideshowSection_Interval',
        description: 'Native_ProGallery_Layout_Slide_Interval_Description',
        min: 2,
        max: 30,
        type: 'NUMBER',
        default: 4,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed,
        title: 'ProGallery_Layout_SlideshowSection_Layout_Speed',
        description: 'ProGallery_Layout_SlideshowSection_Layout_Speed_Tooltip',
        min: 1,
        max: 500,
        type: 'NUMBER',
        default: 50,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.pauseOnHover] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.pauseOnHover,
        title: 'ProGallery_Layout_SlideshowSection_Pause_On_Hover',
        type: 'BOOLEAN',
        default: true,
        description: 'Native_ProGallery_Layout_PauseOnHover_Description',
    },
    _a[optionsMap.layoutParams.navigationArrows.enable] = {
        key: optionsMap.layoutParams.navigationArrows.enable,
        title: 'ProGallery_Design_Navigation_Arrows_Toggle',
        description: 'ProGallery_Design_Navigation_Arrows_Toggle_Tooltip',
        type: 'BOOLEAN',
        default: true,
    },
    // [optionsMap.layoutParams.navigationArrows.type]: {
    //   key: optionsMap.layoutParams.navigationArrows.type,
    //   title: 'Navigation arrows icon',
    //   description:
    //     'Choose the arrows icon for sliding gallery',
    //   type: 'OPTIONS',
    //   default: 0,
    //   options: [
    //     {
    //       value: 0,
    //       title: 'Arrow 1',
    //     },
    //     {
    //       value: 1,
    //       title: 'Arrow 2',
    //     },
    //     {
    //       value: 2,
    //       title: 'Arrow 3',
    //     },
    //   ],
    // },
    // [optionsMap.layoutParams.navigationArrows.container.type]: {
    //   key: optionsMap.layoutParams.navigationArrows.container.type,
    //   title: 'Navigation arrows styling',
    //   description:
    //     'Choose choose how you want to display the arrows',
    //   type: 'OPTIONS',
    //   default: 'SHADOW',
    //   options: [
    //     {
    //       value: 'NONE',
    //       title: 'None',
    //     },
    //     {
    //       value: 'SHADOW',
    //       title: 'Shadow',
    //     },
    //     {
    //       value: 'BOX',
    //       title: 'Box',
    //     },
    //   ],
    // },
    _a[optionsMap.layoutParams.navigationArrows.size] = {
        key: optionsMap.layoutParams.navigationArrows.size,
        title: 'ProGallery_Design_Arrows_Size',
        type: 'NUMBER',
        min: 8,
        max: 150,
        default: 23,
        description: 'Native_ProGallery_Layout_NavigationArrows_Size_Description',
    },
    _a[optionsMap.layoutParams.navigationArrows.position] = {
        key: optionsMap.layoutParams.navigationArrows.position,
        title: 'ProGallery_Design_Arrows_Position_Title',
        type: 'OPTIONS',
        default: 'ON_GALLERY',
        options: [
            {
                value: 'ON_GALLERY',
                title: 'ProGallery_Design_Arrows_Position_On_Gallery',
            },
            {
                value: 'OUTSIDE_GALLERY',
                title: 'ProGallery_Design_Arrows_Position_Outside',
            },
        ],
        description: 'Native_ProGallery_Layout_NavigationArrows_Position_Description',
    },
    _a[optionsMap.layoutParams.navigationArrows.verticalAlignment] = {
        key: optionsMap.layoutParams.navigationArrows.verticalAlignment,
        title: 'ProGallery_settings_design_verticalposition',
        type: 'OPTIONS',
        default: 'ITEM_CENTER',
        options: [
            {
                value: 'ITEM_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_gallery',
            },
            {
                value: 'IMAGE_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_image',
            },
            {
                value: 'INFO_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_text',
            },
        ],
        description: 'MISSING_Set the vertical position of the navigation arrows in sliders. You can choose to position the arrows on the center of the whole item, the center of the image or the center of the info',
    },
    _a[optionsMap.behaviourParams.item.content.hoverAnimation] = {
        key: optionsMap.behaviourParams.item.content.hoverAnimation,
        title: 'ProGallery_Design_Image_Hover_Animation_Label',
        type: 'OPTIONS',
        default: 'NO_EFFECT',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'ProGallery_Design_Image_Hover_Animation_NoEffect',
            },
            {
                value: 'ZOOM_IN',
                title: 'ProGallery_Design_Image_Hover_Animation_ZoomIn',
            },
            {
                value: 'BLUR',
                title: 'ProGallery_Design_Image_Hover_Animation_Blur',
            },
            {
                value: 'GRAYSCALE',
                title: 'ProGallery_Design_Image_Hover_Animation_Grayscale',
            },
            {
                value: 'SHRINK',
                title: 'ProGallery_Design_Image_Hover_Animation_Shrink',
            },
            {
                value: 'INVERT',
                title: 'ProGallery_Design_Image_Hover_Animation_Invert',
            },
            {
                value: 'COLOR_IN',
                title: 'ProGallery_Design_Image_Hover_Animation_ColorIn',
            },
            {
                value: 'DARKENED',
                title: 'ProGallery_Design_Image_Hover_Animation_Darkened',
            },
        ],
        description: 'ProGallery_Design_Image_Hover_Animation_Title',
    },
    _a[optionsMap.behaviourParams.item.content.loader] = {
        key: optionsMap.behaviourParams.item.content.loader,
        title: 'ProGallery_Settings_Image_Loading_Mode',
        description: 'ProGallery_Settings_Image_Loading_Mode_TOOLTIP',
        options: [
            {
                value: 'BLUR',
                title: 'ProGallery_Settings_Image_Loading_Mode_Blur',
            },
            {
                value: 'COLOR',
                title: 'ProGallery_Settings_Image_Loading_Mode_Color',
            },
            {
                value: 'MAIN_COLOR',
                title: 'ProGallery_Settings_Image_Loading_Mode_Color_Main_Color',
            },
        ],
        type: 'OPTIONS',
        default: 'BLUR',
    },
    _a[optionsMap.behaviourParams.item.content.placementAnimation] = {
        key: optionsMap.behaviourParams.item.content.placementAnimation,
        title: 'Image Placement Animation',
        type: 'OPTIONS',
        default: 'NO_EFFECT',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'No Effect',
            },
            {
                value: 'SLIDE',
                title: 'Slide',
            },
        ],
        description: 'Choose an effect that happens to the image when placed/replaced on the gallery.',
    },
    _a[optionsMap.behaviourParams.gallery.scrollAnimation] = {
        key: optionsMap.behaviourParams.gallery.scrollAnimation,
        title: 'ProGallery_Design_Scroll_Animation_Label',
        description: 'ProGallery_Design_Scroll_Animation_TOOLTIP',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'ProGallery_Design_Scroll_Animation_NoEffect',
            },
            {
                value: 'FADE_IN',
                title: 'ProGallery_Design_Scroll_Animation_FadeIn',
            },
            {
                value: 'GRAYSCALE',
                title: 'ProGallery_Design_Scroll_Animation_Grayscale',
            },
            {
                value: 'SLIDE_UP',
                title: 'ProGallery_Design_Scroll_Animation_SlideUp',
            },
            {
                value: 'EXPAND',
                title: 'ProGallery_Design_Scroll_Animation_Expand',
            },
            {
                value: 'SHRINK',
                title: 'ProGallery_Design_Scroll_Animation_Shrink',
            },
            {
                value: 'ZOOM_OUT',
                title: 'ProGallery_Design_Scroll_Animation_ZoomOut',
            },
            {
                value: 'ONE_COLOR',
                title: 'ProGallery_Design_Scroll_Animation_OneColor',
            }
        ],
        type: 'OPTIONS',
        default: 'NO_EFFECT',
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.slideAnimation] = {
        key: optionsMap.behaviourParams.gallery.horizontal.slideAnimation,
        title: 'ProGallery_Design_Slide_Animation_Label',
        type: 'OPTIONS',
        default: 'SCROLL',
        options: [
            {
                value: 'SCROLL',
                title: 'ProGallery_Design_Slide_Animation_Scroll',
            },
            {
                value: 'FADE',
                title: 'ProGallery_Design_Slide_Animation_Fade',
            },
            {
                value: 'DECK',
                title: 'ProGallery_Design_Slide_Animation_Stack',
            },
        ],
        description: 'ProGallery_Design_Slide_Animation_Title',
    },
    _a[optionsMap.behaviourParams.item.video.enablePlayButton] = {
        key: optionsMap.behaviourParams.item.video.enablePlayButton,
        title: 'ProGallery_Settings_Show_Play_Button_Label',
        type: 'BOOLEAN',
        default: true,
        description: 'ProGallery_Layout_SlideshowSection_Play_Button_TOOLTIP',
    },
    _a[optionsMap.behaviourParams.item.video.playTrigger] = {
        key: optionsMap.behaviourParams.item.video.playTrigger,
        title: 'ProGallery_Settings_Play_Label',
        description: 'ProGallery_Settings_Play_Tooltip',
        options: [
            {
                value: 'HOVER',
                title: 'ProGallery_Settings_Hover_Label',
            },
            {
                value: 'AUTO',
                title: 'ProGallery_Settings_Auto_Label',
            },
            {
                value: 'CLICK',
                title: 'ProGallery_Settings_Click_Label',
            },
        ],
        type: 'OPTIONS',
        default: 'HOVER',
    },
    _a[optionsMap.behaviourParams.item.video.speed] = {
        key: optionsMap.behaviourParams.item.video.speed,
        title: 'ProGallery_Settings_Playback_Label',
        type: 'FLOAT',
        min: 0.1,
        max: 10,
        step: 0.1,
        default: 1,
        description: 'Native_ProGallery_Settings_Video_Speed_Description',
    },
    _a[optionsMap.behaviourParams.item.video.volume] = {
        key: optionsMap.behaviourParams.item.video.volume,
        title: 'ProGallery_Settings_Sound_Label',
        type: 'FLOAT',
        default: 0,
        min: 0,
        max: 1,
        step: 0.1,
        description: 'ProGallery_Settings_Sound_Tooltip',
    },
    _a[optionsMap.behaviourParams.item.video.loop] = {
        key: optionsMap.behaviourParams.item.video.loop,
        title: 'ProGallery_Settings_Loop_Label',
        description: 'Native_ProGallery_Settings_Video_Loop_Description',
        type: 'BOOLEAN',
        default: true,
    },
    _a[optionsMap.behaviourParams.item.clickAction] = {
        key: optionsMap.behaviourParams.item.clickAction,
        title: 'ProGallery_Settings_ClickOptions_Label',
        description: 'Native_ProGallery_Settings_ItemClick_Description',
        options: [
            {
                value: 'EXPAND',
                title: 'ProGallery_Settings_ClickOptions_Expand',
            },
            {
                value: 'FULLSCREEN',
                title: 'ProGallery_Settings_ClickOptions_Fullscreen',
            },
            {
                value: 'LINK',
                title: 'ProGallery_Settings_ClickOptions_Link',
            },
            {
                value: 'NOTHING',
                title: 'ProGallery_Settings_ClickOptions_Nothing',
            },
            {
                value: 'MAGNIFY',
                title: 'ProGallery_Expand_Viewing_Settings_Magnifying',
            },
        ],
        type: 'OPTIONS',
        default: 'NOTHING',
    },
    _a[optionsMap.behaviourParams.item.content.magnificationValue] = {
        key: optionsMap.behaviourParams.item.content.magnificationValue,
        title: 'ProGallery_Expand_Viewing_Settings_Magnifying_Size',
        type: 'FLOAT',
        default: 2,
        min: 1.5,
        max: 5,
        step: 0.5,
        description: 'Native_ProGallery_Layout_Expand_MagnifyingSize_Description',
    },
    _a[optionsMap.layoutParams.navigationArrows.padding] = {
        key: optionsMap.layoutParams.navigationArrows.padding,
        title: 'ProGallery_settings_design_Horizontal_padding',
        type: 'NUMBER',
        min: 0,
        max: 100,
        default: 23,
        description: 'Native_ProGallery_Layout_NavigationArrows_Padding_Description',
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.amount] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.amount,
        title: 'ProGallery_Layout_LoadMore_Amount',
        type: 'OPTIONS',
        default: 'ALL',
        options: [
            {
                value: 'PARTIAL',
                title: 'ProGallery_Layout_LoadMore_Amount_Partial',
            },
            {
                value: 'ALL',
                title: 'ProGallery_Layout_LoadMore_Amount_All',
            },
        ],
        description: 'ProGallery_Layout_LoadMore_Amount_Tooltip'
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour,
        title: 'ProGallery_Layout_SlideshowSection_Slide_Automatically',
        type: 'OPTIONS',
        default: 'OFF',
        options: [
            {
                value: 'OFF',
                title: 'Native_ProGallery_Layout_Slideshow_List_Off',
            },
            {
                value: 'INTERVAL',
                title: 'ProGallery_Layout_SlideshowSection_Interval_Header',
            },
            {
                value: 'CONTINUOUS',
                title: 'ProGallery_Layout_SlideshowSection_Continuous_Header',
            },
        ],
        description: "ProGallery_Layout_SlideshowSection_Slide_Automatically_TOOLTIP",
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.slideTransition] = {
        key: optionsMap.behaviourParams.gallery.horizontal.slideTransition,
        title: 'ProGallery_Settings_Design_Slide_Transition_Title',
        description: 'Native_ProGallery_Layout_TransitionEffect_Description',
        options: [
            {
                value: 'linear',
                title: 'ProGallery_Settings_Design_Slide_Transition_Linear',
            },
            {
                value: 'cubic-bezier(0.46,0.1,0.25,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_In_Out',
            },
            {
                value: 'cubic-bezier(0.86,0,0.5,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_In',
            },
            {
                value: 'cubic-bezier(0.31,1.17,0.58,1.07)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_Out',
            },
            {
                value: 'cubic-bezier(0.49,-0.12,0.49,0.04)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_In',
            },
            {
                value: 'cubic-bezier(0.58,1.65,0.29,0.95)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_Out',
            },
            {
                value: 'cubic-bezier(0.6,-0.36,0.41,1.23)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_In_Out',
            },
            {
                value: 'cubic-bezier(0.86,0,0.07,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Expo',
            },
        ],
        type: 'OPTIONS',
        default: 'cubic-bezier(0.46,0.1,0.25,1)',
    },
    _a[optionsMap.layoutParams.info.placement] = {
        key: optionsMap.layoutParams.info.placement,
        title: 'MISSING Info Placement',
        description: 'MISSING_Choose where the info section should be placed',
        options: [
            { value: 'BELOW', title: 'MISSING_Option Show Below' },
            { value: 'ABOVE', title: 'MISSING_Option Show Above' },
            { value: 'RIGHT', title: 'MISSING_Option Show On The Right' },
            { value: 'LEFT', title: 'MISSING_Option Show On The Left' },
            { value: 'OVERLAY', title: 'MISSING_Option Show On Hover' },
            { value: 'ALTERNATE_HORIZONTALLY', title: 'MISSING_Option Alternate Horizontal' },
            { value: 'ALTERNATE_VERTICALLY', title: 'MISSING_Option Alternate Vertical' },
        ],
        type: 'OPTIONS',
        default: 'OVERLAY',
    },
    _a[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE] = {
        key: PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE,
        title: "MISSING Allow Title",
        description: "MISSING_Choose whether the title should be shown in the info section",
        type: "BOOLEAN",
        default: false,
    },
    _a[PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION] = {
        key: PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION,
        title: "MISSING Allow Description",
        description: "MISSING_Choose whether the description should be shown in the info section",
        type: "BOOLEAN",
        default: false,
    },
    _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING] = {
        key: PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING,
        title: "MISSING Texts Vertical Padding",
        description: "MISSING_Choose the vertical padding of the texts in the info section",
        type: "NUMBER",
        min: 0,
        max: 50,
        default: 0,
    },
    _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING] = {
        key: PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING,
        title: "MISSING Texts Horizontal Padding",
        description: "MISSING_Choose the horizontal padding of the texts in the info section",
        type: "NUMBER",
        min: 0,
        max: 50,
        default: 0,
    },
    _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN] = {
        key: PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN,
        title: "MISSING Gallery Vertical Align",
        description: "MISSING_Choose the vertical alignment of the gallery in the info section",
        type: "OPTIONS",
        options: [
            { value: "START", title: "MISSING_Option start" },
            { value: "CENTER", title: "MISSING_Option center" },
            { value: "END", title: "MISSING_Option end" },
        ],
        default: "CENTER",
    },
    _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN] = {
        key: PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN,
        title: "MISSING Gallery Horizontal Align",
        description: "MISSING_Choose the horizontal alignment of the gallery in the info section",
        type: "OPTIONS",
        options: [
            { value: "START", title: "MISSING_Option start" },
            { value: "CENTER", title: "MISSING_Option center" },
            { value: "END", title: "MISSING_Option end" },
        ],
        default: "CENTER",
    },
    _a[optionsMap.layoutParams.info.sizeUnits] = {
        key: optionsMap.layoutParams.info.sizeUnits,
        title: 'MISSING Info Size Units',
        description: 'MISSING_Choose the units for the size of the info section',
        options: [
            { value: 'PIXEL', title: 'MISSING_Option pixel' },
            { value: 'PERCENT', title: 'MISSING_Option percent' },
        ],
        type: 'OPTIONS',
        default: 'PIXEL',
    },
    _a[optionsMap.layoutParams.info.height] = {
        key: optionsMap.layoutParams.info.height,
        title: 'MISSING Info Height (pixel)',
        description: 'MISSING_Choose the height of the info section',
        type: 'NUMBER',
        min: 1,
        max: 400,
        default: 200,
    },
    _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL] = {
        key: PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL,
        title: 'MISSING Info Width in Pixels',
        description: 'MISSING_Choose the width of the info section',
        type: 'NUMBER',
        min: 100,
        max: 1000,
        default: 200,
    },
    _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT] = {
        key: PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT,
        title: 'MISSING Info Width in Percent',
        description: 'MISSING_Choose the width of the info section',
        type: 'NUMBER',
        min: 20,
        max: 90,
        default: 50,
    },
    _a[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] = {
        key: optionsMap.behaviourParams.item.overlay.hoveringBehaviour,
        title: 'MISSING Item Overlay Hovering Behaviour',
        description: 'MISSING_Choose the behaviour of the item overlay when the mouse is hovering over it',
        options: [
            { value: 'APPEARS', title: 'MISSING_Option APPEARS' },
            { value: 'DISAPPEARS', title: 'MISSING_Option DISAPPEARS' },
            { value: 'NO_CHANGE', title: 'MISSING_Option NO_CHANGE' },
            { value: 'NEVER_SHOW', title: 'MISSING_Option NEVER_SHOW' },
        ],
        type: 'OPTIONS',
        default: 'NEVER_SHOW',
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE,
        title: 'MISSING_overlay Type',
        description: 'MISSING_Choose overlay Type',
        options: [
            { value: 'FULL', title: 'ProGallery_Settings_Design_Overlay_Full' },
            { value: 'PARTIAL', title: 'ProGallery_Settings_Design_Overlay_Partial' },
        ],
        type: 'OPTIONS',
        default: 'FULL',
    },
    _a[optionsMap.behaviourParams.item.overlay.sizeUnits] = {
        key: optionsMap.behaviourParams.item.overlay.sizeUnits,
        title: 'MISSING overlay size Type',
        description: 'MISSING_Choose overlay size Type',
        options: [
            { value: 'PIXEL', title: 'PIXEL' },
            { value: 'PERCENT', title: 'PERCENT' },
        ],
        type: 'OPTIONS',
        default: 'PERCENT',
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT,
        title: 'MISSING item overlay percent',
        description: 'MISSING_Choose item overlay percent',
        type: 'NUMBER',
        min: 0,
        max: 100,
        default: 100,
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL,
        title: 'MISSING item overlay Pixels',
        description: 'MISSING_Choose item overlay pixel',
        type: 'NUMBER',
        min: 0,
        max: 1000,
        default: 100,
    },
    _a[optionsMap.behaviourParams.item.overlay.position] = {
        key: optionsMap.behaviourParams.item.overlay.position,
        title: 'MISSING item overlay position',
        description: 'MISSING_Choose item overlay position',
        options: [
            { value: 'LEFT', title: 'LEFT' },
            { value: 'RIGHT', title: 'RIGHT' },
            { value: 'BOTTOM', title: 'BOTTOM' },
            { value: 'TOP', title: 'TOP' },
            { value: 'CENTERED_VERTICALLY', title: 'CENTERED_VERTICALLY' },
            { value: 'CENTERED_HORIZONTALLY', title: 'CENTERED_HORIZONTALLY' },
        ],
        type: 'OPTIONS',
        default: 'BOTTOM',
    },
    _a[optionsMap.behaviourParams.item.overlay.padding] = {
        key: optionsMap.behaviourParams.item.overlay.padding,
        title: 'MISSING item overlay padding',
        description: 'MISSING_Choose item overlay padding',
        type: 'NUMBER',
        min: 0,
        max: 200,
        default: 0,
    },
    _a[optionsMap.behaviourParams.item.overlay.hoverAnimation] = {
        key: optionsMap.behaviourParams.item.overlay.hoverAnimation,
        title: 'MISSING hover Animation',
        description: 'MISSING_Choose hoverAnimation',
        options: [
            { value: 'NO_EFFECT', title: 'NO_EFFECT' },
            { value: 'FADE_IN', title: 'FADE_IN' },
            { value: 'EXPAND', title: 'EXPAND' },
            { value: 'SLIDE_UP', title: 'SLIDE_UP' },
            { value: 'SLIDE_RIGHT', title: 'SLIDE_RIGHT' },
            { value: 'SLIDE_DOWN', title: 'SLIDE_DOWN' },
            { value: 'SLIDE_LEFT', title: 'SLIDE_LEFT' },
        ],
        type: 'OPTIONS',
        default: 'NO_EFFECT',
    },
    _a);
export var ProGallerySettingsOptions = __assign(__assign({}, EditorSections), GalleryOptions);
//# sourceMappingURL=ProGallery.options.js.map